var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{style:({ width: _vm.size + 'px', height: _vm.size + 'px' })},[_c('input',{attrs:{"type":"radio","name":_vm.name},domProps:{"checked":_vm.value},on:{"change":e => {
            _vm.$emit('input', e.target.checked);
            _vm.$emit('change', e.target.checked);
        }}}),_c('em')])
}
var staticRenderFns = []

export { render, staticRenderFns }